export enum mdlReportOptionType {
    Agencies = 0,
    Markets = 1,
    Rooms = 2,
    RoomTypes = 3,
    Boards = 4
}
